import { ControllerModel } from "../_model/ControllerModel";
import { SingletonFlowchart } from "../_service/singletonFlowchart";
import { FermentationBatch } from "./modelFermentationBatch";
import { Current } from "../current/modelCurrent"
import CurrentFermentation from "./fermentationCurrent";
import { SingletonEnginnering } from "../_service/singletonEngineering";

class ControllerFermentationBatch extends ControllerModel {
    constructor() {
        super("ControllerFermentationBatch");

        this.setNewNode = (callback, location) => {
            let fermentationBatch = new FermentationBatch(location);
            fermentationBatch.decorate(callback);
            this.addNode(fermentationBatch);
            SingletonFlowchart.SaveStatus()
        }

        this.loadNode = (node, callback) => {
            let fermentationBatch = new FermentationBatch();
            fermentationBatch.copyFrom(node);
            fermentationBatch.decorate(callback);
            this.addNode(fermentationBatch)
        }

        this.getProperties = async (node) => {
            let n = new FermentationBatch();
            await n.copyFrom(node);
            return n.data
        }

        this.getNode = (node) => {
            let n = new FermentationBatch();
            n.copyFrom(node);
            return n
        }

        this.createCurrents = function (x, y, index){

            CurrentFermentation.forEach(async (c, i) => {
                let current = new Current();
                current.title = c.title
                current.dataType = "CorrenteInterna"
                current.refActive = false
                current.x = x + (i * 170)
                current.y = y

                await current.decorate(SingletonFlowchart.openDialog);
                
                let currentToUpdate = current.clone()
                currentToUpdate.attrs = new Array()

                for(let i in c.props){
                    let p = c.props[i]
                    let map = p.mapping.replace("@", index)
                    let prop = await SingletonEnginnering.getPropertieByToken(map)

                    if(prop){
                        prop.refCalc.caption = p.caption ? p.caption : ''
                        prop.refCalc.equation = p.calc.replace(/@/g, index)
                        prop.refCalc.unit = p.unit ? p.unit : "%"
                        currentToUpdate.attrs.push(prop)
                    }
                }
                
                current.update(currentToUpdate)

                this.addNode(current);
            })  

            SingletonFlowchart.SaveStatus();
        }
    }
}

export { ControllerFermentationBatch };